export const getWishlistId = async ({
    wishlist,
    customerId,
    refetchWishlist,
    createCustomerProductList
}) => {
    if (wishlist?.id) return wishlist.id
    if (!customerId) return null

    try {
        const result = await refetchWishlist?.()
        const lists = result?.data?.data || []
        const existing = lists.find((list) => list.type === 'wish_list')
        if (existing?.id) return existing.id
    } catch (error) {
        console.warn('Unable to refetch wishlist lists', error)
    }

    try {
        const created = await createCustomerProductList({
            parameters: {customerId},
            body: {type: 'wish_list'}
        })
        return created?.id || created?.data?.id || null
    } catch (error) {
        console.warn('Unable to create wishlist', error)
        return null
    }
}
